export default {
    "02-01": {
        year: 1935,
        title: "AYASOFYA VE İPEKÇİ",
        text: "1935'te Ayasofya müze oldu. 1979'da Abdi İpekçi öldürüldü.",
        questions: [
            {
                text: "Ayasofya'nın müzeye dönüştürülmesi kararı hangi yıl ve hangi kurumla alınmıştır?",
                options: ["1934 - Bakanlar Kurulu", "1924 - TBMM", "1930 - İstanbul Belediyesi", "1935 - Vakıflar Genel Md."],
                correct: 0
            },
            {
                text: "3. Ayasofya'nın mimarları kimlerdir?",
                options: ["Mimar Sinan - Davud Ağa", "Trallesli Anthemios - Miletoslu İsidoros", "Sedefkar Mehmet Ağa", "Balyan Kardeşler"],
                correct: 1
            },
            {
                text: "1899'da kurulan Şişli Etfal Hastanesi'nin ilk adı nedir?",
                options: ["Gureba-yi Müslimin", "Hamidiye Etfal Hastanesi", "Darülaceze", "Bezm-i Alem"],
                correct: 1
            }
        ]
    },
    "02-02": {
        year: 1938,
        title: "MERİNOS FABRİKASI",
        text: "1938'de Atatürk, Bursa Merinos Fabrikası'nı açtı.",
        questions: [
            {
                text: "Bursa Merinos Fabrikası hangi plan çerçevesinde inşa edilmiştir?",
                options: ["İzmir İktisat Kongresi", "I. Beş Yıllık Sanayi Planı", "II. Beş Yıllık Sanayi Planı", "Marshall Planı"],
                correct: 1
            },
            {
                text: "I. Beş Yıllık Sanayi Planı'nda Türkiye'ye destek sağlayan devlet hangisidir?",
                options: ["ABD", "Almanya", "Sovyet Rusya (SSCB)", "İngiltere"],
                correct: 2
            },
            {
                text: "'Vaka-i Vakvakiye' (Çınar Vakası) hangi padişah döneminde yaşanmıştır?",
                options: ["IV. Mehmed", "II. Osman", "III. Selim", "I. İbrahim"],
                correct: 0
            }
        ]
    },
    "02-03": {
        year: 1451,
        title: "FATİH'İN İKİNCİ CÜLUSU",
        text: "1451'de II. Mehmed (Fatih) ikinci kez tahta çıktı.",
        questions: [
            {
                text: "II. Mehmed (Fatih), ikinci kez tahta çıktığında ilk hangi beyliğin üzerine yürümüştür?",
                options: ["Karesioğulları", "Karamanoğulları", "Candaroğulları", "Germiyanoğulları"],
                correct: 1
            },
            {
                text: "Fatih'in çocuk yaşta tahta çıktığı dönemde Haçlılara karşı kazanılan savaş hangisidir?",
                options: ["Niğbolu Savaşı", "I. Kosova Savaşı", "Varna Savaşı", "Ankara Savaşı"],
                correct: 2
            },
            {
                text: "Menemen Olayı, Cumhuriyet tarihinde rejime karşı çıkan kaçıncı isyandır?",
                options: ["İlk", "İkinci", "Üçüncü", "Dördüncü"],
                correct: 1
            }
        ]
    },
    "02-04": {
        year: 1923,
        title: "LOZAN VE YALTA",
        text: "1923'te Lozan Konferansı kesintiye uğradı. 1945'te Yalta Konferansı başladı.",
        questions: [
            {
                text: "Lozan Konferansı'nın kesintiye uğramasına neden olan temel konu nedir?",
                options: ["Musul Sorunu", "Ermeni Yurdu", "Kapitülasyonlar - Düyun-ı Umumiye", "Boğazlar"],
                correct: 2
            },
            {
                text: "Lozan'ın kesintiye uğradığı dönemde ekonomik hedefler için ne düzenlenmiştir?",
                options: ["Maarif Kongresi", "İzmir İktisat Kongresi", "Sivas Kongresi", "Pozantı Kongresi"],
                correct: 1
            },
            {
                text: "Yalta Konferansı'na katılan 'Üç Büyükler' kimlerdir?",
                options: ["Roosevelt - Churchill - Stalin", "Truman - Attlee - Stalin", "Wilson - Lloyd George - Lenin", "Eisenhower - Chamberlain - Kruşçev"],
                correct: 0
            }
        ]
    },
    "02-05": {
        year: 1937,
        title: "LAİKLİK VE ALTI OK",
        text: "1937'de CHP'nin Altı Ok'u Anayasa'ya girdi.",
        questions: [
            {
                text: "Laiklik ilkesi fiilen hangi yıl uygulanmaya başlanmıştır (Devletin dini İslam'dır maddesinin çıkarılması)?",
                options: ["1921", "1924", "1928", "1930"],
                correct: 2
            },
            {
                text: "Hangi ilke 1961 Anayasası'nda 'Sosyal Devlet' anlayışına evrilmiştir?",
                options: ["Milliyetçilik", "Devletçilik", "Halkçılık", "İnkılapçılık"],
                correct: 2
            },
            {
                text: "Atatürk İlkeleri anayasaya girdiğinde başbakan kimdi?",
                options: ["İsmet İnönü", "Celal Bayar", "Fethi Okyar", "Refik Saydam"],
                correct: 0
            }
        ]
    },
    "02-06": {
        year: 1933,
        title: "BURSA OLAYI",
        text: "1933'te Bursa'da Türkçe ezan protestosu yaşandı.",
        questions: [
            {
                text: "Bursa Olayı sonrasında görevden alınan devlet yetkilisi kimdir?",
                options: ["Bursa Valisi", "Cumhuriyet Savcısı", "Emniyet Müdürü", "Adalet Bakanı"],
                correct: 1
            },
            {
                text: "Türkiye'de ezan hangi yıl tekrar Arapça okunmaya başlanmıştır?",
                options: ["1946", "1950", "1960", "1938"],
                correct: 1
            },
            {
                text: "'Bu bir din meselesi değil, dil meselesidir' sözü neyi vurgular?",
                options: ["Dinin yasaklanması", "İbadetin Türkçeleştirilmesi", "Dinin devletten ayrılması", "Halifelik"],
                correct: 1
            }
        ]
    },
    "02-07": {
        year: 1992,
        title: "AB VE MAASTRICHT",
        text: "1992'de Maastricht Antlaşması ile AB resmen kuruldu.",
        questions: [
            {
                text: "AB üyesi ülkelerin ekonomik kriterlerini düzenleyen kriterlere ne ad verilir?",
                options: ["Kopenhag Kriterleri", "Maastricht Kriterleri", "Lizbon Kriterleri", "Roma Kriterleri"],
                correct: 1
            },
            {
                text: "Türkiye AET'ye ilk tam üyelik başvurusunu hangi yıl yapmıştır?",
                options: ["1959", "1963", "1987", "1999"],
                correct: 0
            },
            {
                text: "1963'te Türkiye ile AET arasında 'Ortaklık' statüsü kuran antlaşma hangisidir?",
                options: ["Ankara Antlaşması", "Katma Protokol", "Gümrük Birliği", "Paris Şartı"],
                correct: 0
            }
        ]
    },
    "02-08": {
        year: 1921,
        title: "GAZİANTEP SAVUNMASI",
        text: "1921'de TBMM, Antep'e 'Gazi' unvanını verdi.",
        questions: [
            {
                text: "'Benim cesedimi çiğnemeden Antep'e giremezsiniz' diyen kahraman kimdir?",
                options: ["Sütçü İmam", "Şahin Bey", "Ali Saip Ursavaş", "Yörük Ali Efe"],
                correct: 1
            },
            {
                text: "TBMM tarafından şehirlere unvan verilmesi kronolojik olarak nasıldır?",
                options: ["Maraş - Antep - Urfa", "Antep - Maraş - Urfa", "Urfa - Antep - Maraş", "Antep - Urfa - Maraş"],
                correct: 1
            },
            {
                text: "Güney Cephesi savaşlarını sona erdiren antlaşma hangisidir?",
                options: ["Gümrü Antlaşması", "Kars Antlaşması", "Ankara Antlaşması (1921)", "Moskova Antlaşması"],
                correct: 2
            }
        ]
    },
    "02-09": {
        year: 1934,
        title: "BALKAN ANTANTI",
        text: "1934'te Türkiye, Yunanistan, Yugoslavya ve Romanya arasında Balkan Antantı imzalandı.",
        questions: [
            {
                text: "Balkan Antantı'na Bulgaristan'ın katılmama nedeni temel olarak neydi?",
                options: ["Sovyet baskısı", "Ege'ye inme isteği (Revizyonist politika)", "Türkiye husumeti", "Ekonomik yetersizlik"],
                correct: 1
            },
            {
                text: "Balkan Antantı'nda Türkiye adına aktif rol oynayan Dışişleri Bakanı kimdir?",
                options: ["Tevfik Rüştü Aras", "Yusuf Kemal Tengirşenk", "Fatin Rüştü Zorlu", "Hasan Saka"],
                correct: 0
            },
            {
                text: "1934 Balkan Antantı hangi gelişme ile fiilen geçerliliğini yitirmiştir?",
                options: ["I. Dünya Savaşı", "II. Dünya Savaşı", "Kore Savaşı", "NATO"],
                correct: 1
            }
        ]
    },
    "02-10": {
        year: 1918,
        title: "II. ABDÜLHAMİD'İN VEFATI",
        text: "1918'de II. Abdülhamid vefat etti. 1947'de Paris Barış Antlaşmaları imzalandı.",
        questions: [
            {
                text: "II. Abdülhamid'in tahttan indirilmesine neden olan olay hangisidir?",
                options: ["31 Mart Vakası", "Bâb-ı Âli Baskını", "Çırağan Baskını", "Kuleli Vakası"],
                correct: 0
            },
            {
                text: "1947 Paris Barış Antlaşması ile 'On İki Ada' kime devredilmiştir?",
                options: ["Türkiye", "İngiltere", "Yunanistan", "ABD"],
                correct: 2
            },
            {
                text: "II. Abdülhamid döneminin resmi politikası hangisidir?",
                options: ["Osmanlıcılık", "İslamcılık", "Türkçülük", "Batıcılık"],
                correct: 1
            }
        ]
    },
    "02-11": {
        year: 1929,
        title: "LATERAN ANTLAŞMASI",
        text: "1929'da Vatikan bağımsız oldu. 2011'de Mısır'da Mübarek istifa etti.",
        questions: [
            {
                text: "Lateran Antlaşması'nı İtalya adına imzalayan faşist lider kimdir?",
                options: ["Benito Mussolini", "Victor Emmanuel", "Cavour", "Garibaldi"],
                correct: 0
            },
            {
                text: "Arap Baharı ilk olarak 2010 yılında hangi ülkede başlamıştır?",
                options: ["Mısır", "Suriye", "Tunus", "Libya"],
                correct: 2
            },
            {
                text: "Aşağıdaki kurumlardan hangisinin merkezi Vatikan değildir?",
                options: ["San Pietro Bazilikası", "Papalık Makamı", "Kızılhaç", "Sistina Şapeli"],
                correct: 2
            }
        ]
    },
    "02-12": {
        year: 1919,
        title: "TRABZON MHC VE ZÜRİH",
        text: "1919'da Trabzon Muhafaza-i Hukuk kuruldu. 1959'da Zürih Antlaşması imzalandı.",
        questions: [
            {
                text: "Trabzon Muhafaza-i Hukuk, Erzurum Kongresi için hangi cemiyetle iş birliği yapmıştır?",
                options: ["Kilikyalılar", "Vilayat-ı Şarkiye Müdafaa-i Hukuk", "Trakya Paşaeli", "Reddi İlhak"],
                correct: 1
            },
            {
                text: "Kıbrıs Cumhuriyeti'nin ilk Cumhurbaşkanı kimdir?",
                options: ["Rauf Denktaş", "Makarios", "Nikos Sampson", "Grivas"],
                correct: 1
            },
            {
                text: "Milli Mücadele'de yararlı cemiyetlerin birleştiği çatı kuruluşun adı nedir?",
                options: ["Anadolu ve Rumeli Müdafaa-i Hukuk", "Kuvâ-yi Milliye", "Felah-ı Vatan", "Karakol Cemiyeti"],
                correct: 0
            }
        ]
    },
    "02-13": {
        year: 1925,
        title: "ŞEYH SAİD İSYANI",
        text: "1925'te Şeyh Said İsyanı başladı. 1660'ta İsveç-Danimarka savaşı bitti.",
        questions: [
            {
                text: "Şeyh Said İsyanı sürecinde çıkarılan olağanüstü yetki kanunu hangisidir?",
                options: ["Hıyanet-i Vataniye", "Takrir-i Sükûn", "Teşkilat-ı Esasiye", "Tekalif-i Milliye"],
                correct: 1
            },
            {
                text: "Şeyh Said İsyanı sırasında istifa eden Fethi Okyar yerine kim başbakan olmuştur?",
                options: ["Celal Bayar", "İsmet İnönü", "Refik Saydam", "Şemsettin Günaltay"],
                correct: 1
            },
            {
                text: "İsyan nedeniyle İngiltere hangi bölgeyi Musul Sorunu kapsamında kendi lehine çözmüştür?",
                options: ["Batum", "Hatay", "Musul ve Kerkük", "Batı Trakya"],
                correct: 2
            }
        ]
    },
    "02-14": {
        year: 1878,
        title: "MECLİSİN KAPATILMASI",
        text: "1878'de II. Abdülhamid meclisi kapattı. 1946'da ENIAC tanıtıldı.",
        questions: [
            {
                text: "II. Abdülhamid'in meclisi kapatmasına neden olan savaş hangisidir?",
                options: ["Kırım Savaşı", "Dömeke Savaşı", "93 Harbi", "Trablusgarp Savaşı"],
                correct: 2
            },
            {
                text: "Meclis-i Mebusan'da padişah tarafından atanan üyelerin oluşturduğu kanat hangisidir?",
                options: ["Meclis-i Ayan", "Meclis-i Vükela", "Şura-yı Devlet", "Divan-ı Ahkam"],
                correct: 0
            },
            {
                text: "İlk bilgisayar ENIAC hangi amaçla geliştirilmiştir?",
                options: ["İnternet", "Balistik hesaplama", "Hava durumu", "Satranç"],
                correct: 1
            }
        ]
    },
    "02-15": {
        year: 1999,
        title: "ÖCALAN'IN YAKALANMASI",
        text: "1999'da Abdullah Öcalan yakalandı. MÖ 399'da Sokrates idam edildi.",
        questions: [
            {
                text: "Sokrates'in öğrencisi olan ve 'Devlet' adlı eseriyle tanınan filozof kimdir?",
                options: ["Aristoteles", "Platon (Eflatun)", "Herakleitos", "Diyojen"],
                correct: 1
            },
            {
                text: "1999'da Öcalan yakalandığında Türkiye'de başbakan kimdi?",
                options: ["Mesut Yılmaz", "Tansu Çiller", "Bülent Ecevit", "Necmettin Erbakan"],
                correct: 2
            },
            {
                text: "SSCB, 15 Şubat 1989'da hangi ülkeden tamamen çekilmiştir?",
                options: ["Vietnam", "Kore", "Afganistan", "Çeçenistan"],
                correct: 2
            }
        ]
    },
    "02-16": {
        year: 1925,
        title: "TÜRK TAYYARE CEMİYETİ",
        text: "1925'te Türk Tayyare Cemiyeti (THK) kuruldu. 2005'te Kyoto Protokolü yürürlüğe girdi.",
        questions: [
            {
                text: "Türk Tayyare Cemiyeti'nin ilk başkanı kabul edilen asker ve siyasetçi kimdir?",
                options: ["Nuri Demirağ", "Vecihi Hürkuş", "Cevat Abbas Gürer", "Şakir Zümre"],
                correct: 2
            },
            {
                text: "Cumhuriyetin ilk yıllarında havacılık alanında çalışan özel girişimci kimdir?",
                options: ["Nuri Demirağ", "Refik Koraltan", "Adnan Menderes", "Hasan Polatkan"],
                correct: 0
            },
            {
                text: "Kyoto Protokolü'nün temel amacı nedir?",
                options: ["Nükleer silahları azaltmak", "Sera gazı salınımını düşürmek", "Deniz kirliliği", "Hayvanları korumak"],
                correct: 1
            }
        ]
    },
    "02-17": {
        year: 1926,
        title: "MEDENİ KANUN VE İKTİSAT",
        text: "1926'da Medeni Kanun kabul edildi. 1923'te İzmir İktisat Kongresi toplandı.",
        questions: [
            {
                text: "Türk Medeni Kanunu hazırlanırken hangi ülkenin kanunu örnek alınmıştır?",
                options: ["Fransa", "İtalya", "İsviçre", "Almanya"],
                correct: 2
            },
            {
                text: "Hangisi 1926 Medeni Kanunu ile kadınlara verilen haklardan biri değildir?",
                options: ["Mirasta eşitlik", "Meslek hakkı", "Resmi nikah", "Seçme ve seçilme hakkı"],
                correct: 3
            },
            {
                text: "İzmir İktisat Kongresi'nin başkanlığını yapan komutan kimdir?",
                options: ["İsmet İnönü", "Kâzım Karabekir", "Fevzi Çakmak", "Refet Bele"],
                correct: 1
            }
        ]
    },
    "02-18": {
        year: 1856,
        title: "ISLAHAT FERMANI VE NATO",
        text: "1856'da Islahat Fermanı ilan edildi. 1952'de Türkiye NATO'ya üye oldu.",
        questions: [
            {
                text: "Islahat Fermanı hangi padişah ve sadrazam döneminde hazırlanmıştır?",
                options: ["II. Mahmud - Mustafa Reşit", "Abdülmecid - Mehmet Emin Ali", "Abdülaziz - Fuat Paşa", "V. Murad - Midhat Paşa"],
                correct: 1
            },
            {
                text: "Türkiye'nin NATO üyeliğini hızlandıran savaş hangisidir?",
                options: ["II. Dünya Savaşı", "Körfez Savaşı", "Kore Savaşı", "Kıbrıs Barış Harekatı"],
                correct: 2
            },
            {
                text: "Islahat Fermanı ile gayrimüslimlere verilen hangi hak Müslüman halkın tepkisini çekmiştir?",
                options: ["Banka kurma", "Devlet memurluğu", "Bedelli askerlik", "Yasaklanan ifadeler"],
                correct: 1
            }
        ]
    },
    "02-19": {
        year: 1915,
        title: "ÇANAKKALE DENİZ VE MENDERES",
        text: "1915'te Çanakkale deniz harekatı başladı. 1959'da Menderes uçak kazası geçirdi.",
        questions: [
            {
                text: "19 Şubat 1915'te Çanakkale Müstahkem Mevkii Komutanı kimdi?",
                options: ["Esat Paşa", "Cevat (Çobanlı) Paşa", "Kazım Karabekir", "Enver Paşa"],
                correct: 1
            },
            {
                text: "Menderes'in uçak kazası, hanki antlaşma için yapılan seyahatte gerçekleşti?",
                options: ["Londra Antlaşması (Kıbrıs)", "Bağdat Paktı", "Balkan Antantı", "Ankara Antlaşması"],
                correct: 0
            },
            {
                text: "'Hababam Sınıfı' romanının yazarı kimdir?",
                options: ["Rıfat Ilgaz", "Aziz Nesin", "Muzaffer İzgü", "Orhan Kemal"],
                correct: 0
            }
        ]
    },
    "02-20": {
        year: 1970,
        title: "BOĞAZİÇİ KÖPRÜSÜ",
        text: "1970'te Boğaziçi Köprüsü'nün temeli atıldı. 2015'te Fırat Yılmaz Çakıroğlu şehit edildi.",
        questions: [
            {
                text: "Boğaziçi Köprüsü'nü inşa eden konsorsiyum hangi ülkelere aittir?",
                options: ["Almanya - İngiltere", "İngiltere - Almanya", "Japonya - İtalya", "ABD - Fransa"],
                correct: 0
            },
            {
                text: "Boğaziçi'ne köprü projesini II. Abdülhamid'e sunan Fransız mühendis kimdir?",
                options: ["Ferdinand von Zeppelin", "Leonardo da Vinci", "Fernand Arnodin", "Gustave Eiffel"],
                correct: 2
            },
            {
                text: "'Toplum Sözleşmesi' eseriyle tanınan ve egemenliğin halka ait olduğunu savunan düşünür kimdir?",
                options: ["Montesquieu", "Voltaire", "Jean-Jacques Rousseau", "John Locke"],
                correct: 2
            }
        ]
    },
    "02-21": {
        year: 1965,
        title: "MALCOLM X VE ATATÜRK",
        text: "1965'te Malcolm X öldürüldü. 1923'te Atatürk Time kapağında yer aldı.",
        questions: [
            {
                text: "Malcolm X'in sözcülüğünü yaptığı ancak sonra ayrıldığı hareketin adı nedir?",
                options: ["Kara Panterler", "İslam Milleti (Nation of Islam)", "Sivil Haklar", "Müslüman Kardeşler"],
                correct: 1
            },
            {
                text: "Malcolm X'in Müslüman olduktan sonra aldığı isim nedir?",
                options: ["Malik El-Şahbaz", "Muhammed Ali", "Kerim Abdülcabbar", "Elijah Muhammed"],
                correct: 0
            },
            {
                text: "Atatürk, Time dergisinin kapağında hangi sıfatla nitelendirilmiştir?",
                options: ["Modern Türkiye'nin Kurucusu", "Muhteşem Türk", "Bir Ulusun Babası", "Sadık Bir Lider"],
                correct: 1
            }
        ]
    },
    "02-22": {
        year: 1962,
        title: "TALAT AYDEMİR AYAKLANMASI",
        text: "1962'de Talat Aydemir darbe girişiminde bulundu. 1834'te Kara Harp Okulu kuruldu.",
        questions: [
            {
                text: "Talat Aydemir'in darbe girişimi sırasında başbakan kimdi?",
                options: ["Adnan Menderes", "Süleyman Demirel", "İsmet İnönü", "Nihat Erim"],
                correct: 2
            },
            {
                text: "Kara Harp Okulu (Mekteb-i Harbiye) hangi padişah döneminde açılmıştır?",
                options: ["III. Selim", "II. Mahmud", "Abdülmecid", "II. Abdülhamid"],
                correct: 1
            },
            {
                text: "Darwin'in 'Türlerin Kökeni' eseri hangi yüzyılda yayımlanmıştır?",
                options: ["18. Yüzyıl", "19. Yüzyıl (1859)", "20. Yüzyıl", "17. Yüzyıl"],
                correct: 1
            }
        ]
    },
    "02-23": {
        year: 1945,
        title: "ALMANYA'YA SAVAŞ İLANI",
        text: "1945'te Türkiye Almanya'ya savaş ilan etti. 1921'de Londra Konferansı başladı.",
        questions: [
            {
                text: "Londra Konferansı'nda Tevfik Paşa'nın sözü TBMM'ye bırakması neyin göstergesidir?",
                options: ["İtilaf planının işe yaradığının", "İstanbul'un TBMM'yi tanımadığının", "İtilaf'ın 'ikilik çıkarma' planının suya düştüğünün", "Tevfik Paşa'nın TBMM'ye katılacağının"],
                correct: 2
            },
            {
                text: "Türkiye'nin Almanya'ya savaş ilan etmesinin temel amacı nedir?",
                options: ["Toprak almak", "BM kurucu üyesi olmak", "Rus işgalini engellemek", "Marshall Planı"],
                correct: 1
            },
            {
                text: "Londra Konferansı sonrasında Yunan ordusu hangi savaşı başlatmıştır?",
                options: ["I. İnönü", "II. İnönü", "Kütahya-Eskişehir", "Sakarya"],
                correct: 1
            }
        ]
    },
    "02-24": {
        year: 1942,
        title: "STRUMA FACİASI",
        text: "1942'de Struma gemisi batırıldı. 1955'te Bağdat Paktı kuruldu.",
        questions: [
            {
                text: "Struma gemisini batıran Sovyet denizaltısının adı (kod numarası) nedir?",
                options: ["U-571", "SC-213", "K-19", "Kursk"],
                correct: 1
            },
            {
                text: "Bağdat Paktı'ndan 1958'de çekilen ülke hangisidir?",
                options: ["İran", "Pakistan", "Irak", "İngiltere"],
                correct: 2
            },
            {
                text: "1954'te Tuna Nehri buzlarının Boğaz'ı kaplaması olayı nasıl anılır?",
                options: ["Boğaz'ın Donması", "Tuna Faciası", "Buzlu Şubat", "Beyaz Kıyamet"],
                correct: 0
            }
        ]
    },
    "02-25": {
        year: 1991,
        title: "VARŞOVA PAKTI'NIN SONU",
        text: "1991'de Varşova Paktı askeri kanadı lağvedildi. 1925'te dini siyasete alet etme yasağı geldi.",
        questions: [
            {
                text: "Varşova Paktı'nın kuruluş antlaşması hangi şehirde imzalanmıştır?",
                options: ["Moskova", "Varşova", "Prag", "Budapeşte"],
                correct: 1
            },
            {
                text: "'Dini siyasete alet etmek' suçunun Hıyanet-i Vataniye'ye eklenmesi hangi olayla olmuştur?",
                options: ["Menemen Olayı", "İzmir Suikastı", "Şeyh Said İsyanı", "Çerkez Ethem"],
                correct: 2
            },
            {
                text: "Varşova Paktı'ndan ayrılan ilk ve tek devlet hangisidir?",
                options: ["Romanya", "Arnavutluk", "Yugoslavya", "Macaristan"],
                correct: 1
            }
        ]
    },
    "02-26": {
        year: 1992,
        title: "HOCALI KATLİAMI",
        text: "1992'de Hocalı Katliamı yaşandı. 1815'te Napolyon Elba'dan kaçtı.",
        questions: [
            {
                text: "Hocalı Katliamı'nda Ermenilere destek veren Rus birliğinin adı nedir?",
                options: ["366. Motorize Piyade", "Kızıl Ordu 1. Tümen", "Wagner Grubu", "Spetsnaz"],
                correct: 0
            },
            {
                text: "Napolyon'un kesin olarak yenildiği son savaşı hangisidir?",
                options: ["Leipzig", "Waterloo", "Austerlitz", "Trafalgar"],
                correct: 1
            },
            {
                text: "1926'dan sonra 'Merkezi İstatistik Dairesi' adını alan kurum günümüzde hangisidir?",
                options: ["DPT", "TÜBİTAK", "TÜİK", "RTÜK"],
                correct: 2
            }
        ]
    },
    "02-27": {
        year: 2011,
        title: "NECMETTİN ERBAKAN'IN VEFATI",
        text: "2011'de Necmettin Erbakan vefat etti. 1933'te Reichstag yangını çıktı.",
        questions: [
            {
                text: "Milli Görüş hareketinin ilk siyasi partisi hangisidir?",
                options: ["Milli Selamet Partisi", "Refah Partisi", "Milli Nizam Partisi", "Saadet Partisi"],
                correct: 2
            },
            {
                text: "Reichstag Yangını sonrası Hitler'in yetkileri devraldığı yasa nedir?",
                options: ["Yetki Kanunu", "Nürnberg Yasaları", "Mein Kampf Yasası", "Kristallnacht"],
                correct: 0
            },
            {
                text: "Erbakan'ın başbakanlık yaptığı Refahyol hükümeti hangi partiyle kurulmuştur?",
                options: ["Milliyetçi Cephe", "Refahyol (DYP)", "Anasol-D", "Azınlık"],
                correct: 1
            }
        ]
    },
    "02-28": {
        year: 1997,
        title: "28 ŞUBAT SÜRECİ",
        text: "1997'de MGK kararlarıyla 'Post-modern Darbe' süreci başladı.",
        questions: [
            {
                text: "28 Şubat sürecinde tankların yürütülmesi emrini verdiği iddia edilen komutan kimdir?",
                options: ["İsmail Hakkı Karadayı", "Hüseyin Kıvrıkoğlu", "Çevik Bir", "Doğan Güreş"],
                correct: 2
            },
            {
                text: "Refahyol yıkıldıktan sonra hükümeti kurma görevi kime verilmiştir?",
                options: ["Tansu Çiller", "Mesut Yılmaz", "Bülent Ecevit", "Devlet Bahçeli"],
                correct: 1
            },
            {
                text: "'28 Şubat bin yıl sürecek' diyen komutan kimdir?",
                options: ["Hüseyin Kıvrıkoğlu", "Hilmi Özkök", "Yaşar Büyükanıt", "İlker Başbuğ"],
                correct: 0
            }
        ]
    },
    "02-29": {
        year: 1940,
        title: "ARTIK GÜN VE OSCAR",
        text: "Dört yılda bir gelen Artık Gün. 1940'ta Hattie McDaniel Oscar kazanan ilk siyahi oldu.",
        questions: [
            {
                text: "Miladi Takvim'in temeli olan ve 1582'de düzeltilen takvim hangisidir?",
                options: ["Celali Takvimi", "Rumi Takvim", "Jülyen Takvimi", "12 Hayvanlı Türk Takvimi"],
                correct: 2
            },
            {
                text: "Osmanlı'da mali işler için kullanılan Rumi Takvim hangi padişah döneminde başlamıştır?",
                options: ["III. Selim", "II. Mahmud", "Abdülmecid", "Abdülaziz"],
                correct: 2
            },
            {
                text: "Türkiye'de Miladi Takvim'e geçilmeden önce kullanılan son tarih hangisidir? (1 Ocak 1926'dan bir gün önce)",
                options: ["31 Aralık 1925", "31 Kanunuevvel 1341", "29 Zilhicce 1344", "1 Mart 1341"],
                correct: 1
            }
        ]
    }
};
